import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigService } from 'src/app/shared/config';
import { AnnouncementService } from '../../../services/announcement.service';
import { SubscriptionService } from '../../../services/kampanje.service';
import { map } from 'rxjs';

@Component({
  selector: 'app-announcement-form',
  templateUrl: './announcement-form.component.html',
  styleUrls: ['./announcement-form.component.css'],
})
export class AnnouncementFormComponent implements OnInit {
  subscriptionForm: FormGroup;
  isEditMode = false;
  systems = [];
  categories = [];
  @ViewChild('mySelect') mySelect;
  daysOfWeek = [{ name: 'Monday', index: 1 }, { name: 'Tuesday', index: 2 }, { name: 'Wednesday', index: 3 }, { name: 'Thursday', index: 4 }, { name: 'Friday', index: 5 }, { name: 'Saturday', index: 6 }, { name: 'Sunday', index: 7 }];

  // Filtered list that will be shown in the select
  filteredSystems: any[] = [...this.systems];

  // Selected systems (using ngModel)
  selectedSystems: string[] = [];
  kampanjeSub: any;
  kampanjeArr: any;
  usedKampanje: any;
  constructor(
    private fb: FormBuilder,
    private config: ConfigService,
    public dialogRef: MatDialogRef<AnnouncementFormComponent>,
    public kampanjeService: SubscriptionService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.systems = data.systems;
    this.usedKampanje = data.usedKampanje;
    this.subscriptionForm = this.fb.group({
      announcement: ['', Validators.required],
      type: ['', Validators.required],
      kampanje: [[]],  // add validators if needed
      systems: [''],
      startTime: [''],
      endTime: [''],
      priority: [''],
      selectedDays: [''],
      active: [''],
      windowColor: ['#0d6efd'],
      textColor: ['#ffffff']
    });

    if (data.eventData) {
      this.isEditMode = true;
      const subscription = data.eventData;
      this.subscriptionForm.patchValue({
        companyId: this.config.getCompanyId(),
        systems: subscription.systems,
        announcement: subscription.announcement,
        type: subscription.type,
        kampanje: subscription.kampanje,
        active: subscription.active,
        startTime: subscription.startTime, // Convert Unix time to HH:mm
        endTime: subscription.endTime, // Convert Unix time to HH:mm
        priority: subscription.priority,
        selectedDays: subscription.selectedDays,
        windowColor: subscription.windowColor || '#0d6efd',
        textColor: subscription.textColor || '#ffffff'
      });
    }
  }
  ngOnInit(): void {
    this.filteredSystems = [...this.systems];
    this.loadKampanje();
  }


  loadKampanje(): void {
    this.kampanjeSub = this.kampanjeService.getCategorySubscriptions().pipe(map(sp => {
      return sp.map((doc) => {
        return { id: doc.payload.doc.id, ...doc.payload.doc.data() }
      })
    }))
    this.kampanjeSub.subscribe(data => {
      this.kampanjeArr = data.map(kampanje => ({
        ...kampanje,
        disable: this.usedKampanje.some(usedK => usedK.kampanje.includes(kampanje.id))
      }));
    });
  }

  filterSystems(search: string): void {
    if (!search) {
      this.filteredSystems = [...this.systems];
      return;
    }
    this.mySelect.open();
    const lowerSearch = search.toLowerCase();
    this.filteredSystems = this.systems.filter(system =>
      system.systemName.toLowerCase().includes(lowerSearch)
    );
  }


  onSubmit() {
    if (this.subscriptionForm.valid) {

      const formValue = this.subscriptionForm.value;

      this.dialogRef.close(formValue);
    }
  }


}